import { useQuery } from "@tanstack/react-query";

import { getDocumentTypes } from "@/api/documentTypes";

export function useDocumentTypes() {
  return useQuery({
    queryKey: ["document-types"],
    queryFn: getDocumentTypes,
    staleTime: Infinity,
  });
}
